export const KEY_CODES = {
    LEFT: 37,
    RIGHT: 39,
    DOWN: 40,
    UP: 38,
    ENTER: 13,
    BACKSPACE: 8
}